<h2 mat-dialog-title>Gruppe bearbeiten</h2>

<mat-dialog-content>
  <form [formGroup]="editForm" ngxsForm="resourceGroups.editForm" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput type="text" formControlName="name" placeholder="Name der Gruppe" cdkFocusInitial required/>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!(canSave$ | async)">Speichern</button>
</mat-dialog-actions>
